import styled from 'styled-components';

import { rem } from 'polished';

const Label = styled.label`
  color: #aaa;
  font-weight: 700;
  margin-bottom: ${rem(5)};
  font-size: ${({ theme }) => theme.md};
`;

export default Label;
